export class LinkListModel {
  content: string;
  url: string;
}
